// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as IncognitoComponent} from './Incognito.svg';

import Icon, { TIconProps } from '../Icon';

export const IconIncognito = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <IncognitoComponent/>
  </Icon>
));
